import Box from "../components/box";
import Btn from "../components/btn";
import Input from "../components/input";
import h from "../core/createElement";
import Modal from "../core/modalEngine";
import popupAlerts from "../core/popupAlerts";

function ConfirmTypeFile({ hide, confirm }) {
    const
        shared = {},
        items = [
            { label: "Principal", value: "main_report" },
            { label: "Sub Relatório", value: "sub_report" }
        ];


    const _confirm = () => {
        if (!shared.input.element.value) {
            popupAlerts.warning("Selecione o tipo do relatório!");
            return shared.input.invalid(true);
        };
        shared.input.invalid(false);

        hide();
        confirm(shared.input.element.value);
    };

    return (
        <Box title="Selecionar Tipo" buttons={<Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />}>
            <section class="flex-column p6px">
                <Input title="Tipo de relatório" items={items} type="select" shared={shared} />

                <div class="bottom-btns">
                    <Btn title="Cancelar" color="red" onClick={() => hide()} />
                    <Btn title="Confirmar" color="green" onClick={_confirm} />
                </div>
            </section>
        </Box>
    );
};

const ConfirmTypeFileModal = new Modal(ConfirmTypeFile);

export default ConfirmTypeFileModal;